// Where the run stream resumes (V6 plan 13.3.2; docs/HEADLESS.md section 4, "Following a run").
// Every envelope's SSE `id:` is its sequence, and frames arrive at least once across reconnects,
// so the cursor keeps the last sequence yielded: a reconnect sends it as `Last-Event-ID`, and a
// frame at or below it is a repeat, dropped.
//
// Before any envelope is yielded the cursor resumes from where the stream began: after the
// caller's `after`, from the start for a full replay, or, for a connection opened at the head
// (`?from=head`), after the head its `state` frame named. The state frame carries no `id:`, so
// the cursor remembers that head itself and reopens with `?after=<head>`; asking for the head
// again would skip whatever was logged while it reconnected, and a full replay that drops before
// its first envelope simply replays again. Lifted from the H0 CLI, which resumes through this
// package since H1.12.
export class ResumeCursor {
    yielded = null;
    anchor;
    fromHead;
    constructor(start = {}) {
        this.anchor = start.after ?? null;
        this.fromHead = start.fromHead === true && start.after === undefined;
    }
    /** The last sequence yielded; null before any. */
    get last() {
        return this.yielded;
    }
    /** The sequence everything so far runs through: -1 before any, or the start's anchor. */
    get through() {
        return this.yielded ?? this.anchor ?? -1;
    }
    resume() {
        if (this.yielded !== null)
            return { lastEventId: this.yielded };
        if (this.anchor !== null)
            return { after: this.anchor };
        return this.fromHead ? { from: "head" } : null;
    }
    /** A connection's `state` frame: one opened at the head anchors there until an envelope is yielded. */
    opened(state) {
        if (this.yielded === null && this.anchor === null && this.fromHead && state.head !== undefined)
            this.anchor = state.head;
    }
    /** Whether this sequence is new, and if so it becomes the last yielded: a repeat is false. */
    accept(sequence) {
        const floor = this.yielded ?? this.anchor;
        if (floor !== null && sequence <= floor)
            return false;
        this.yielded = sequence;
        return true;
    }
}
//# sourceMappingURL=cursor.js.map